import React from 'react'
import { graphql, useStaticQuery } from "gatsby";
import './button.scss'

const Button = props => {
    const { title, className, onClick, disabled, gtm } = props

    const { contentfulInformacionGeneral } = useStaticQuery(
        graphql`{
          contentfulInformacionGeneral{
            textoDeBotonesEnMaysculas
          }
        }`
    );
    const { textoDeBotonesEnMaysculas } = contentfulInformacionGeneral;

    return (
        <div className="a-button-container ">
            <button
                className={
                    `a-button ` + (disabled ? 'disabled ' : '')
                    + ( typeof className !== 'undefined' ? `${ className } ` : '' )
                    + ( textoDeBotonesEnMaysculas  ? ' uppercase' : '')
                    + ( typeof gtm !== 'undefined' ? ' ' + gtm : '' )
                }
                onClick={onClick}
            >
                {title}
            </button>
        </div>
    )
}

export default Button
